import React, { useState, useRef, useEffect } from 'react';
import './Voucher.css';
import { Link } from 'react-router-dom';
import { vouchers } from '../data/vouchersData';
 
export default function Voucher({ onAddToCart }) {
  const [confirmed, setConfirmed] = useState(null);
  const [showFind, setShowFind] = useState(false);
  const [email, setEmail] = useState('');
  const [foundVouchers, setFoundVouchers] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupVoucher, setPopupVoucher] = useState(null);
  const [popupEmail, setPopupEmail] = useState('');
  // Remove swipeConfirmed and showCheck state

  const sliderRef = useRef(null);
  const [sliderX, setSliderX] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [dragStart, setDragStart] = useState(null);

  // Reset slider and drag state when popup closes
  useEffect(() => {
    setSliderX(0);
    setDragging(false);
    setDragStart(null);
  }, [showPopup]);

  // Drag event handlers
  useEffect(() => {
    if (!dragging) return;
    const handleMove = (e) => {
      let clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      const rect = sliderRef.current.getBoundingClientRect();
      let x = clientX - rect.left - 20;
      if (x < 0) x = 0;
      if (x > 200) x = 200;
      setSliderX(x);
    };
    const handleUp = () => {
      if (sliderX > 180 && popupEmail) {
        setShowPopup(false);
        setConfirmed(popupVoucher); // Show confirmation on main page
      } else {
        setSliderX(0);
      }
      setDragging(false);
      setDragStart(null);
    };
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('touchmove', handleMove);
    window.addEventListener('mouseup', handleUp);
    window.addEventListener('touchend', handleUp);
    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('touchmove', handleMove);
      window.removeEventListener('mouseup', handleUp);
      window.removeEventListener('touchend', handleUp);
    };
  }, [dragging, sliderX, popupEmail, popupVoucher]);

  const handleBook = (voucher) => {
    setConfirmed(voucher);
  };

  const handleBuyNow = (voucher) => {
    setPopupVoucher(voucher);
    setShowPopup(true);
    setPopupEmail('');
    // Remove swipeConfirmed and showCheck state
  };

  // Email validation helper
  const isValidEmail = (email) => /.+@.+\..+/.test(email);
  const [emailError, setEmailError] = useState('');

  const handleSliderDown = (e) => {
    if (!isValidEmail(popupEmail)) {
      setEmailError('Enter a valid email');
      return;
    }
    setEmailError('');
    e.preventDefault();
    setDragging(true);
    setDragStart(e.type.includes('touch') ? e.touches[0].clientX : e.clientX);
  };
  const handleSliderUp = () => {
    setDragging(false);
  };
  const handleSliderMove = (e) => {
    if (!dragging) return;
    let clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const rect = sliderRef.current.getBoundingClientRect();
    let x = clientX - rect.left - 20;
    if (x < 0) x = 0;
    if (x > 200) x = 200;
    setSliderX(x);
  };

  const handleFind = (e) => {
    e.preventDefault();
    // Mock: always show all vouchers for any email
    setFoundVouchers(vouchers);
  };

  return (
    <>
      <div className="voucher-hero section">
        <div className="container">
          <div className="section-title">
            <h5>Our Loyalty Booklets</h5>
            <h2>Book & Save on Eco-Friendly Car Care</h2>
            <p>Purchase or retrieve your eco-friendly car wash vouchers for great savings and a cleaner planet. Quick, easy, and account-free!</p>
          </div>
        </div>
      </div>
      <div className="voucher-page">
        <div className="breadcrumb">
          <Link to="/">Home</Link> / Loyalty Booklet
        </div>
        <h2 className="voucher-title">Get your Loyalty Booklet today!</h2>
        {!confirmed ? (
          <div className="voucher-list">
            {vouchers.map((voucher) => (
              <div className="voucher-card" key={voucher.id}>
                <h3>{voucher.title}</h3>
                <p>{voucher.washes}</p>
                <p>{voucher.descriptionGrid}</p>
                <div className="voucher-price">Total:OMR {voucher.price.toFixed(2)} <span className="voucher-old-price">{voucher.oldPrice.toFixed(2)}</span>({voucher.offer} %Off) </div>
                <div className="voucher-actions-col">
                  <Link to={`/loyalty-booklet/${voucher.id}`} className="voucher-btn">
                    Learn More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="voucher-confirmation">
            <h3>Thank you for booking!</h3>
            <p>Your voucher: <strong>{confirmed.title}</strong></p>
            <p>(This is a mock confirmation. No payment was processed.)</p>
            <button className="voucher-btn" onClick={() => setConfirmed(null)}>
              Book Another
            </button>
          </div>
        )}

        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-form">
              <h3>Enter your Email</h3>
              <input
                type="email"
                value={popupEmail}
                onChange={e => setPopupEmail(e.target.value)}
                placeholder="Enter your email"
                required
                style={{marginBottom: '1rem', padding: '0.5rem', width: '100%'}}
              />
              <div
                className="swipe-slider-container"
                ref={sliderRef}
                style={{position: 'relative', width: '100%', maxWidth: 240, margin: '0 auto 1rem', height: 48, opacity: isValidEmail(popupEmail) ? 1 : 0.5, pointerEvents: isValidEmail(popupEmail) ? 'auto' : 'none'}}
              >
                <div className="swipe-slider-track">
                  <span className="swipe-slider-text">Swipe to Buy</span>
                </div>
                <div
                  className="swipe-slider-thumb"
                  style={{left: sliderX, transition: dragging ? 'none' : 'left 0.2s', cursor: isValidEmail(popupEmail) ? 'pointer' : 'not-allowed'}}
                  onMouseDown={handleSliderDown}
                  onTouchStart={handleSliderDown}
                  role="button"
                  tabIndex={0}
                  aria-label="Swipe to Buy"
                >
                  <i className="fas fa-arrow-right"></i>
                </div>
              </div>
              {emailError && (
                <div style={{color: 'red', marginBottom: '0.5rem', textAlign: 'center'}}>{emailError}</div>
              )}
              <button onClick={() => setShowPopup(false)} style={{background: 'none', border: 'none', color: '#888', cursor: 'pointer'}}>Cancel</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
} 